import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'
import { useAuth } from '../contexts/AuthContext'

const { FiLogOut } = FiIcons

const Header = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  const handleSignOut = async () => {
    await logout()
    navigate('/login')
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-4">
            <img
              src="https://moringapowder.com/cdn/shop/files/Pura_Vida_logo.png?v=1614806534&width=240"
              alt="Pura Vida Moringa"
              className="h-12 w-auto object-contain"
              onError={(e) => {
                e.currentTarget.src = '/logo.png'
              }}
            />
            <div className="hidden md:block h-8 w-px bg-gray-200"></div>
            <p className="hidden md:block text-sm text-gray-500 font-medium">
              Certificate Lookup
            </p>
          </Link>

          <nav className="flex items-center space-x-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-600'
                  : 'text-gray-600 hover:text-primary-600'
              }`}
            >
              Search Certificates
            </Link>

            {user ? (
              <div className="flex items-center space-x-4">
                <Link
                  to="/admin"
                  className={`text-sm font-medium transition-colors ${
                    location.pathname.startsWith('/admin')
                      ? 'text-primary-600'
                      : 'text-gray-600 hover:text-primary-600'
                  }`}
                >
                  Admin Dashboard
                </Link>
                <button
                  onClick={handleSignOut}
                  className="flex items-center space-x-2 text-sm font-medium text-gray-600 hover:text-primary-600 transition-colors"
                >
                  <SafeIcon icon={FiLogOut} className="text-sm" />
                  <span>Sign Out</span>
                </button>
              </div>
            ) : (
              <Link
                to="/login"
                className="text-sm font-medium text-gray-600 hover:text-primary-600 transition-colors"
              >
                Admin Login
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
